import React, { Component } from 'react'
import './styles.css'
import { logError } from 'utils/datadog'
import { createVideoService } from 'services'
import { Events, ConnectionType } from 'constants/videoService'

class VisitCheckIn extends Component {
  constructor(props) {
    super(props)
    this.state = {
      activeRoom: null,
    }
    this.localMedia = React.createRef()
    this.remoteMedia = React.createRef()
    this.onRoomConnectionSuccess = this.onRoomConnectionSuccess.bind(this)
    this.onRoomConnectionFailure = this.onRoomConnectionFailure.bind(this)
  }

  async componentDidMount() {
    if (this.props.webrtcToken && this.props.roomName) {
      this.videoService = await this.setupVideoService()
      this.videoService.connect().then(this.onRoomConnectionSuccess, this.onRoomConnectionFailure)
    } else {
      console.error('twilioToken and twilioRoomId should be provided as URL parameters')
    }
  }

  async setupVideoService() {
    const videoService = await createVideoService(this.props.webrtcToken.provider, {
      webrtcToken: this.props.webrtcToken,
      roomName: this.props.roomName,
      connectionType: ConnectionType.VISIT_CHECKIN
    })
    videoService.on(Events.ROOM_DISCONNECTED, this.onRoomDisconnected)
    return videoService
  }

  onRoomConnectionSuccess(room) {
    console.log('Connected to Room "%s"', room.name)
    console.log('LocalParticipantSID: "%s"', room.localParticipant.sid)

    this.setState({ activeRoom: room })
    this.videoService.configureLocalParticipant(this.localMedia.current)
    this.videoService.configureRemoteParticipants([this.remoteMedia.current])
  }

  onRoomDisconnected(room, error) {
    if (error) {
      error.message = `Twilio ${error.code} - ${error.message}`
      logError(error, {
        appointmentId: this.props.appointmentId,
        userId: room.localParticipant.identity,
        participantSid: room.localParticipant.sid,
        roomName: room.name,
        roomSID: room.sid,
        errorCode: error.code,
        errorMessage: error.message
      })
    }
  }

  onRoomConnectionFailure(err) {
    console.error('Failed to join Twilio room with error: ' + err)
    err.message = `Twilio ${err.code} - ${err.message}`
    logError(err, { roomName: this.props.roomName })
  }

  render() {
    return (
      <div styleName='videoPage'>
        <div styleName='visitContent'>
          <div styleName='videoInputContainer' id='localMedia' ref={this.localMedia} />
          <div styleName='videoOutputContainer' id='remoteMedia' ref={this.remoteMedia} />
        </div>
      </div>
    )
  }
}

export default VisitCheckIn
